export const DP3_LIST: {
    title: string; // 标题 —— 写死
    subTitle: string; // 副标题 —— 写死
    img: string;
    variantId: string;
    productId: string;
    price: number;
    compareAtPrice: number;
    param?: string;
    inventoryQuantity?: string;
    desc?: string;
}[] = [
    {
        title: 'Starter Kit',
        subTitle: 'EcoFlow DELTA Pro 3',
        img: 'https://websiteoss.ecoflow.com/upload/image/1726800079992/dd.png',
        param: '4kWh | 230V | 4000W',
        desc: 'A single unit can effortlessly cover your essential power needs.',
        price: 4099,
        compareAtPrice: 6699,
        productId: '8311879925958',
        variantId: '44062870503622',
    },
    {
        title: 'Extended Ease Kit',
        img: 'https://websiteoss.ecoflow.com/upload/image/1726800079992/dd.png',
        param: '8kWh | 230V | 4000W',
        desc: 'Expandable up to 48kWh.',
        price: 7299,
        compareAtPrice: 10599,
        subTitle: 'EcoFlow DELTA Pro 3 + DELTA Pro 3 Smart Extra Battery',
        productId: '8311879925958',
        variantId: '44062870536390',
    },
    {
        title: 'Power On-the-go',
        img: 'https://websiteoss.ecoflow.com/upload/image/1726800079992/dd.png',
        desc: 'Get your energy needs covered even on the go.',
        price: 4599,
        compareAtPrice: 7498,

        subTitle: 'EcoFlow DELTA Pro 3 + 800W Alternator Charger',
        productId: '8311879925958',
        variantId: '44062870634694',
    },
    {
        title: 'Solar-Powered Freedom',
        img: 'https://websiteoss.ecoflow.com/upload/image/1726800079992/dd.png',
        price: 5199,
        compareAtPrice: 7899,

        subTitle: 'EcoFlow DELTA Pro 3 + 400W Solar Panel',
        productId: '8311879925958',
        variantId: '44062870601926',
    },
    {
        title: 'Ultimate Climate Control',
        img: 'https://websiteoss.ecoflow.com/upload/image/1726800079992/dd.png',
        price: 5699,
        compareAtPrice: 8698,
        subTitle: 'EcoFlow DELTA Pro 3 + WAVE 2',
        productId: '8311879925958',
        variantId: '44062870667462',
    },
];
